<div>
    <label soho-label attr.for="{{automationId}}">{{fieldLabel}}</label>
    <input
        type="text"
        attr.data-automation-id="{{automationId}}"
        id="{{automationId}}"
        name="{{automationId}}"
        soho-alert
        soho-lookup
        soho-busyindicator
        blockUI="true"
        displayDelay="0"
        [click]="onLookupClick"
        (change)="onValueChanged($event)"
        [(ngModel)]="fieldValue"
    />
</div>